import { Component, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Navigation } from './components/navigation/navigation';
import { Toolbar } from './components/toolbar/toolbar';

import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AuthenticationService } from './services/authentication.service';
import { InteractionStatus } from '@azure/msal-browser';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  providers: [MessageService],
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    Navigation,
    Toolbar,
    FormsModule,
    ToastModule
],

  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('PCR-WEB');
  shouldNavigateAfterToast = false;
  navigateAfterToastRoute: any[] = ['/my-requests']; // Default route

  constructor(private authService: AuthenticationService, private router: Router, private messageService: MessageService, private msalBroadcastService: MsalBroadcastService) {
  }

  ngOnInit(): void {
    this.authService.checkAndSetActiveAccount();
    this.authService.setLoginDisplay();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None) // Only proceed when InteractionStatus is None
      )
      .subscribe(() => {
        this.router.events
          .pipe(
            filter(event => event instanceof NavigationEnd), // Only handle NavigationEnd events
            take(1) // Complete the subscription after the first NavigationEnd event
          )
          .subscribe(() => {
            const currentUrl = this.router.url;
            // Only redirect if at root (no path, no query, no fragment)
            if (currentUrl === '/' || currentUrl === '') {
              if (this.authService.isGateKeeper) {
                this.router.navigate(['/all-requests']);
              } else {
                this.router.navigate(['/my-requests']);
              }
            }
          });
      });
  }

  ngOnDestroy(): void {
  }

  onToastClosed() {
    if (this.shouldNavigateAfterToast) {
      this.router.navigate(this.navigateAfterToastRoute);
      this.shouldNavigateAfterToast = false;
      this.navigateAfterToastRoute = ['/my-requests']; // Reset to default if needed
    }
  }
}
